import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of, tap, throwError } from 'rxjs';
import { LocalStorageService } from './local-storage.service';
import { APP_CONFIG, AppConfig } from '../config/app-config';

interface HttpOptions {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  context?: HttpContext;
  observe?: 'body';
  params?:
    | HttpParams
    | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
      };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  transferCache?:
    | {
        includeHeaders?: string[];
      }
    | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CachingHttpClient {

  private static readonly CACHE_PREFIX = 'CachingHttpClient';

  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: AppConfig,
    private readonly httpClient: HttpClient,
    private readonly localStorageService: LocalStorageService,
  ) {
  }

  get<T>(path: string, options?: HttpOptions): Observable<T> {
    const cacheKey = `${CachingHttpClient.CACHE_PREFIX}.${path}${options?.params?.toString() || ''}`;

    if (navigator.onLine) {
      return this.httpClient.get<T>(`${this.appConfig.newApiUrl}${path}`, options).pipe(
        tap((value) => {
          this.localStorageService.set<T>(cacheKey, value);
        }),
      );
    } else if (this.localStorageService.exists(cacheKey)) {
      return of(this.localStorageService.get<T>(cacheKey)!);
    } else {
      return throwError(() => new Error('error.offline.without.cached.response'));
    }
  }

  clear() {
    this.localStorageService.deleteAllWithPrefix(CachingHttpClient.CACHE_PREFIX);
  }

}
